// ====================================================
// src/components/block/liveStreamManagement/enchainements/FlashEnchainement.tsx
//
// Fondu vers une couleur à mi-course, puis fondu depuis cette couleur vers le
// preview — le montage "flash cut" classique. Seul enchaînement avec un
// réglage de couleur pour l'instant.
// ====================================================

import React from 'react';
import { Enchainement, EnchainementControlProps, EnchainementRenderInput } from './Enchainement';

export interface FlashConfig { color: string; }

const PRESET_COLORS = ['#ffffff', '#000000', '#f43f5e', '#38bdf8', '#facc15'];

class FlashEnchainementImpl extends Enchainement<FlashConfig> {
  readonly id = 'flash';
  readonly label = 'Flash coupé';
  readonly icon = 'Zap';
  readonly defaultConfig: FlashConfig = { color: '#ffffff' };

  render(input: EnchainementRenderInput, config: FlashConfig): void {
    const { ctx, currentSource, currentRect, nextSource, nextRect, progress, width, height } = input;
    const color = config.color || '#ffffff';

    if (progress < 0.5) {
      const t = progress / 0.5;
      ctx.drawImage(currentSource, currentRect.x, currentRect.y, currentRect.w, currentRect.h);
      if (t > 0) {
        ctx.save();
        ctx.globalAlpha = t;
        ctx.fillStyle = color;
        ctx.fillRect(0, 0, width, height);
        ctx.restore();
      }
    } else {
      const t = (progress - 0.5) / 0.5;
      ctx.fillStyle = color;
      ctx.fillRect(0, 0, width, height);
      if (t > 0) {
        ctx.save();
        ctx.globalAlpha = t;
        ctx.drawImage(nextSource, nextRect.x, nextRect.y, nextRect.w, nextRect.h);
        ctx.restore();
      }
    }
  }

  renderControls({ config, onChange }: EnchainementControlProps<FlashConfig>): React.ReactNode {
    return (
      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
        {PRESET_COLORS.map(c => (
          <button
            key={c}
            onClick={() => onChange({ color: c })}
            title={c}
            style={{
              width: 24, height: 24, borderRadius: '50%', background: c, cursor: 'pointer',
              border: c === config.color ? '2px solid #34d399' : '2px solid rgba(255,255,255,0.2)',
              boxShadow: c === config.color ? '0 0 6px rgba(52,211,153,0.6)' : 'none',
              padding: 0,
            }}
          />
        ))}
        <input
          type="color"
          value={config.color}
          onChange={e => onChange({ color: e.target.value })}
          title="Couleur personnalisée"
          style={{ width: 24, height: 24, padding: 0, border: 'none', background: 'none', cursor: 'pointer' }}
        />
      </div>
    );
  }
}

export const flashEnchainement = new FlashEnchainementImpl();
